import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 1500 } }

  connect() {
    if (!this.urlValue) return

    this.timeout = window.setTimeout(() => {
      window.location.assign(this.urlValue)
    }, this.delayValue)
  }

  disconnect() {
    if (this.timeout) window.clearTimeout(this.timeout)
  }
}
